import { render, staticRenderFns } from "./input-ad.vue?vue&type=template&id=6bcf3d70&"
import script from "./input-ad.vue?vue&type=script&lang=js&"
export * from "./input-ad.vue?vue&type=script&lang=js&"
import style0 from "./input-ad.vue?vue&type=style&index=0&id=6bcf3d70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports